import { Col, Modal, Row, Typography } from "antd"
import { ExclamationCircleTwoTone } from "@ant-design/icons/lib"
import Bugsnag from "@bugsnag/js"

export function ConfirmModal({ title, body, onOk, onCancel,width = 350,  ...props }){
  const handleOk = async () => {
    try {
      await onOk()
      onCancel()
    } catch (e) {
      Bugsnag.notify(new Error(e))
    }
  }
  return (
    <Modal
      width={width}
      onCancel={onCancel}
      onOk={handleOk}
      maskClosable={false}
      {...props}>
      <Row gutter={[10, 8]}>
        <Col><ExclamationCircleTwoTone twoToneColor="#F9BD55" /></Col>
        <Col>
          <Typography.Text strong>{title}</Typography.Text>
          <br />
          <Typography.Text>{body}</Typography.Text>
        </Col>
      </Row>
    </Modal>
  )
}
